import { useState } from "react";
import { CheckCircle2Icon, CheckIcon, LinkIcon } from "lucide-react";

import { Column, Row } from "@/components";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

export const IntakeCompletionDialog = ({
  entityName,
  onOpenChange,
  open,
  shareUrl,
  type,
}: {
  entityName: string;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  shareUrl: string;
  type: "company" | "job";
}) => {
  const [copied, setCopied] = useState(false);

  const message =
    type === "company"
      ? `Already know which staffer will be working for ${entityName}? Share this with them or the entire staffing-pod so they can familiarize themselves with the client!`
      : `Already know which staffer will be working to fill the ${entityName} role? Share this with them or the entire staffing-pod so they can familiarize themselves with the job before taking on the reqs!`;

  const screenName =
    type === "company" ? MIXPANEL_SCREENS.COMPANY : MIXPANEL_SCREENS.JOB;

  const handleShare = () => {
    void navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    mixpanelUtils.trackButtonClick("Share Intake Link", screenName);

    setTimeout(() => {
      setCopied(false);
    }, 5000);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <Row className="items-center gap-2">
            <CheckCircle2Icon className="h-6 w-6 text-green-600" />
            <DialogTitle className="text-lg">Intake Complete!</DialogTitle>
          </Row>
        </DialogHeader>
        <Column className="gap-4">
          <p className="text-sm text-slate-600">{message}</p>
          <Button
            className="gap-2 self-start px-0"
            onClick={handleShare}
            variant="ghost"
          >
            {copied ? (
              <CheckIcon className="h-4 w-4" />
            ) : (
              <LinkIcon className="h-4 w-4" />
            )}
            {copied ? "Link Copied!" : "Copy Share Link"}
          </Button>
        </Column>
      </DialogContent>
    </Dialog>
  );
};
